<template>
	<div>
		<mainHead :title="mainHeadTitle" :crumbsList="crumbsList"></mainHead>
		<div class="mainBox">
			<div class="titleTips">修改密码</div>
			<div class="inputRow flex_start" style="margin-top: 20px;">
				<div class="inputTips">原密码：</div>	<!-- <span class="notRequired">*</span> -->
				<div class="screenInput">
					<el-input class="inputWidth" type="password" size="small" placeholder="请输入密码" v-model="oldPassword" clearable></el-input>
				</div>
			</div>
			<div class="inputRow flex_start">
				<div class="inputTips">新密码：</div>	<!-- <span class="notRequired">*</span> -->
				<div class="screenInput">
					<el-input class="inputWidth" type="password" size="small" placeholder="请输入密码" v-model="password" clearable></el-input>
				</div>
			</div>
			<div class="inputRow flex_start">
				<div class="inputTips">确认新密码：</div>
				<div class="screenInput">
					<el-input class="inputWidth" type="password" size="small" placeholder="请输入密码" v-model="repeatPassword" clearable></el-input>
				</div>
			</div>
			<!-- <div class="flex_start">
				<div class="inputRow flex_start" >
					<div class="inputTips">信息补充：</div>
					<div class="richText">
					    <el-input size="medium" type="textarea" placeholder="房产证号，印花税票，以及编号,地址，产权人，面积" v-model="formdata.room_note" resize="none"
					    	:autosize="{ minRows: 3, maxRows: 6}"></el-input>
					</div>
				</div>
				<div class="inputRow flex_start">
					<div class="inputTips">房产产权：</div>
					<div class="screenInput flex_start" style="margin-top: 2px;">
						<el-radio-group v-model="formdata.room_rights">
							<el-radio :label="1">40年</el-radio>
							<el-radio :label="2">50年</el-radio>
							<el-radio :label="3">70年</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div> -->
			
			<div class="btnList flex_start">
				<div class="screenBtn" @click="confirm"><el-button size="medium" type="primary">保存</el-button></div>
				<!-- <div class="screenBtn" @click="cancal"><el-button size="medium" type="info">返回</el-button></div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				mainHeadTitle:'修改密码',
				crumbsList:['修改密码'],
				oldPassword:'',
				password:'',
				repeatPassword:'',
				// followTypeList:[],
				formdata:{},
				avatar_image:'',//缩略图上传回显
				avatar:'',//缩略图上传
			}
		},
		mounted() {
			// this.getUserData();
		},
		methods:{
			//点击提交
			confirm(){
				// this.formdata['user_id'] = this.id
				// this.formdata['type'] = 'roomCreated'
				// if(this.avatar){
				// 	this.formdata['avatar'] = this.avatar
				// }
				if(!this.oldPassword){
					this.$message({
					    message: '请输入原密码',
					     type: 'warning'
					});
					return
				}
				if(!this.password){
					this.$message({
					    message: '请输入密码',
					     type: 'warning'
					});
					return
				}
				if(!this.repeatPassword){
					this.$message({
					    message: '请再次输入密码',
					     type: 'warning'
					});
					return
				}
				if(this.password==this.oldPassword){
					this.$message({
					    message: '新旧密码一致，请重试',
					     type: 'warning'
					});
					return
				}
				if(this.password!=this.repeatPassword){
					this.$message({
					    message: '两次输入的密码不一致，请重试',
					     type: 'warning'
					});
					return
				}
				let data = {type:'updatedPwd',password:this.password,oldPassword:this.oldPassword}
				this.$http.post(this.$api.user,data).then(res => {
					if (res.code == 200) {
						this.$message({
						    message: '保存成功',
						     type: 'success'
						});
						localStorage.clear();
						setTimeout(()=>{
							location.reload();
						},1000)
					}else{
						this.$message({
						    message: res.msg,
						     type: 'error'
						});
					}
				})
			},
			// 获取账号信息
			getUserData() {
				let data = {type:'memberInfo'}
				this.$http.post(this.$api.user,data).then(res => {
					console.log(res);
					if (res.code == 200) {
						this.formdata = res.data
						if(res.data.avatar){
							this.avatar_image = res.data.avatar_image
							this.avatar = res.data.avatar
						}
					}
				})
			},
		}
	}
</script>

<style scoped>
	.mainBox{
		padding: 20px;
		box-sizing: border-box;
		width: 100%;
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		margin-top: 30px;
		background: #FFFFFF;
	}
	.titleTips{
		font-size: 18px;
		font-weight: 600;
		margin-bottom: 10px;
	}

	
	
	.inputRow{
		margin: 10px 0;
		width: 46%;
	}
	.inputTips{
		width: 130px;
		line-height: 32px;
		/* padding-left: 15px; */
		box-sizing: border-box;
		font-size: 14px;
	}
	.infoContent{
		line-height: 32px;
		font-size: 14px;
	}
	.unitText{
		font-size: 14px;
		line-height: 32px;
		margin: 0 10px;
	}
	.screenInput{
		align-items: center;
		height: 32px;
		/* min-width: 300px; */
	}
	.richText{
		width: 500px;
		margin-top: 5px;
	}
	
	.btnList{
		margin: 15px 0;
		margin-top: 30px;
	}
	.screenBtn{
		margin-left: 130px;
	}
	.addImg{
		width: 100px;
		height: 100px;
		border: 1px dashed #eee;
		margin: 10px 0;
		align-items: center;
	}
	.addImg img{
		width: 16px;
		height: 16px;
	}
	.upload_img{
		width: 100px;
		height: 100px;
		margin: 10px 0;
	}
</style>
